// extracted by mini-css-extract-plugin
module.exports = {"logos":"PaymentLogos_logos_1V3_B"};